function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/page-master");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "7.03125e-05 0 45 0 45 47.9999652 7.03125e-05 47.9999652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "7.03125e-05 0 45 0 45 44.5217043 7.03125e-05 44.5217043"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-217.000000, -585.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/page-master",
  transform: "translate(217.000000, 585.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7813203,47.9999652 L4.21882031,47.9999652 C1.88901563,47.9999652 7.03125e-05,46.1310957 7.03125e-05,43.8260522 L7.03125e-05,4.17387826 C7.03125e-05,1.86883478 1.88901563,-3.47826087e-05 4.21882031,-3.47826087e-05 L40.7813203,-3.47826087e-05 C43.111125,-3.47826087e-05 45.0000703,1.86883478 45.0000703,4.17387826 L45.0000703,43.8260522 C45.0000703,46.1310957 43.111125,47.9999652 40.7813203,47.9999652",
  id: "Fill-1",
  fill: "#739DD8",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7813203,44.5217043 L4.21882031,44.5217043 C1.88901563,44.5217043 7.03125e-05,42.6528348 7.03125e-05,40.3477913 L7.03125e-05,4.17387826 C7.03125e-05,1.86883478 1.88901563,-3.47826087e-05 4.21882031,-3.47826087e-05 L40.7813203,-3.47826087e-05 C43.111125,-3.47826087e-05 45.0000703,1.86883478 45.0000703,4.17387826 L45.0000703,40.3477913 C45.0000703,42.6528348 43.111125,44.5217043 40.7813203,44.5217043",
  id: "Fill-4",
  fill: "#AFCBF9",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M35.0107383,14.1682087 L33.4448789,14.1682087 L11.3379258,14.1682087 L9.98933203,14.1682087 C9.24999609,14.1682087 8.65093359,14.7612522 8.65093359,15.4923826 L8.65093359,30.2061217 C8.65093359,30.9372522 9.24999609,31.5302957 9.98933203,31.5302957 L19.5697617,31.5302957 C19.5697617,32.5049043 20.3685117,33.2951652 21.3535898,33.2951652 L23.6464805,33.2951652 C24.6319102,33.2951652 25.4306602,32.5049043 25.4306602,31.5302957 L35.0107383,31.5302957 C35.7500742,31.5302957 36.3491367,30.9372522 36.3491367,30.2061217 L36.3491367,15.4923826 C36.3491367,14.7612522 35.7500742,14.1682087 35.0107383,14.1682087",
  id: "Fill-7",
  fill: "#001593"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.2319727,29.1248696 L25.4304492,29.1248696 C24.065332,29.1248696 22.9174805,29.9937391 22.5922852,31.1693913 L22.4077148,31.1693913 C22.0825195,29.9937391 20.9353711,29.1248696 19.5695508,29.1248696 L11.7673242,29.1248696 C11.3658398,29.1248696 11.0392383,28.8024348 11.0392383,28.4045217 L11.0392383,11.9471304 C11.0392383,11.5495652 11.3658398,11.2264348 11.7673242,11.2264348 L19.5695508,11.2264348 C21.187793,11.2264348 22.5001758,12.4469565 22.5001758,13.9523478 C22.5001758,12.4469565 23.8118555,11.2264348 25.4304492,11.2264348 L33.2319727,11.2264348 C33.6341602,11.2264348 33.9600586,11.5488696 33.9600586,11.9471304 L33.9600586,28.4045217 C33.9600586,28.8024348 33.6341602,29.1248696 33.2319727,29.1248696",
  id: "Fill-9",
  fill: "#F3F7FF"
}), /*#__PURE__*/React.createElement("line", {
  x1: 22.5000703,
  y1: 13.7410435,
  x2: 22.5000703,
  y2: 30.4311304,
  id: "Stroke-11",
  stroke: "#E2E9F2",
  strokeWidth: 1.73913043,
  strokeLinecap: "round"
})))));

var SvgPageMaster = function SvgPageMaster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPageMaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/page-master.bc8649e1.svg";
export { ForwardRef as ReactComponent };